<template>
    <div class="pad20">
        <div class="opportunity_sec">
            <!-- <div class="opportunity-title">
                <h3>
                    Job Oppurtunity Information
                </h3>    
            </div> -->
        <div class="vx-row blockmargin main-list-panel" >
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'classOfAdmission') ">
                <div class="main-list">
                    <p>
                        Class of Admission
                        <span>{{checkProperty(petition,'permEfileInfo' ,'classOfAdmission')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'skillLevel') ">
                <div class="main-list">
                    <p>
                        Skills Level
                        <span>{{checkProperty(petition,'permEfileInfo' ,'skillLevel')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'isEmployerInvolved')">
                <div class="main-list">
                    <p>
                        The employer a closely held corporation, partnership, or sole proprietorship in which the alien has an ownership interest, or is there a familial relationship between the owners, stockholders, partners, corporate officers, or incorporators, and the alien
                        <span>{{checkProperty(petition,'permEfileInfo' ,'isEmployerInvolved')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'supportOfAScheduleASheepherder')">
                <div class="main-list">
                    <p>
                        This application in support of a Schedule A or Sheepherder occupation
                        <span>{{checkProperty(petition,'permEfileInfo' ,'supportOfAScheduleASheepherder')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'supervisedRecruitment')">
                <div class="main-list">
                    <p>
                        Is the employer required, by notice from a Certifying Officer, to currently undergo supervised recruitment in accordance with 20 CFR 656.21?
                        <span>{{checkProperty(petition,'permEfileInfo' ,'supervisedRecruitment')}}</span>
                    </p>
                </div>
            </div>
            <!-- Document Section -->
            <vs-col class="padl0 padr0" v-if="checkProperty(petition['permEfileInfo'],'docIfSupervisedRecruitment','length')>0" >
                <documentsView @download_or_view="download_or_view" :type="'docIfSupervisedRecruitment'"  :documentsList="petition['permEfileInfo']['docIfSupervisedRecruitment']" :petitionDetails="petition" />
            </vs-col>
            <!-- <h4>Wage Information</h4> -->
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'pwdOfferedWage') && checkProperty(petition['permEfileInfo'] ,'pwdOfferedWage', 'minWage')">
                <div class="main-list">
                    <p>
                        Minimum Wage
                        <span>{{checkProperty(petition['permEfileInfo'] ,'pwdOfferedWage', 'minWage')| formatprice}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'pwdOfferedWage') && checkProperty(petition['permEfileInfo'] ,'pwdOfferedWage', 'maxWage')">
                <div class="main-list">
                    <p>
                        Maximum Wage
                        <span>{{checkProperty(petition['permEfileInfo'] ,'pwdOfferedWage', 'maxWage')| formatprice}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'pwdOfferedWage') && checkProperty(petition['permEfileInfo'] ,'pwdOfferedWage', 'payFrequency')">
                <div class="main-list">
                    <p>
                        Pay Frequency
                        <span>{{checkProperty(petition['permEfileInfo'] ,'pwdOfferedWage', 'payFrequency')}}</span>
                    </p>
                </div>
            </div>
             <!-- <h4>Worksite Information</h4> -->
             <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'worksiteInfo') && checkProperty(petition['permEfileInfo'] ,'worksiteInfo', 'wsLocation')">
                <div class="main-list">
                    <p>
                        Type of worksite location that best describes where work will be performed
                        <span>{{formatWorkSite(checkProperty(petition['permEfileInfo'] ,'worksiteInfo', 'wsLocation'))}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'worksiteInfo') && checkProperty(petition['permEfileInfo'] ,'worksiteInfo', 'msaOrOesAreaCode')">
                <div class="main-list">
                    <p>
                        MSA/OES Area Code
                        <span>{{checkProperty(petition['permEfileInfo'] ,'worksiteInfo', 'msaOrOesAreaCode')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition,'permEfileInfo' ,'worksiteInfo') && checkProperty(petition['permEfileInfo'] ,'worksiteInfo', 'msaOrOesAreaTitle')">
                <div class="main-list">
                    <p>
                        MSA Name/OES Area Title
                        <span>{{checkProperty(petition['permEfileInfo'] ,'worksiteInfo', 'msaOrOesAreaTitle')}}</span>
                    </p>
                </div>
            </div>
             <!-- <h4>Additional Job Opportunity Information and Other Requirements</h4> -->
             <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'permanentFullTime')">
                <div class="main-list">
                    <p>
                        Is this a permanent position offering full-time employment of generally 35 hours or more
                        <span>{{checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'permanentFullTime')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'relyingOnWorkerExp')">
                <div class="main-list">
                    <p>
                        Is the employer relying solely on the experience the foreign worker while working for the employer, including as a contract employee to qualify him/her for the job opportunity covered by this application?
                        <span>{{checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'relyingOnWorkerExp')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'compareWorkExp')">
                <div class="main-list">
                    <p>
                        Did the foreign worker gain any of the qualifying experience with the employer in a position substantially comparable to the job opportunity identified in Section F of the PWD identified in Question E.1?
                        <span>{{checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'compareWorkExp')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'empPaidWorkerEducation')">
                <div class="main-list">
                    <p>
                        Did the employer pay for any of the foreign worker’s education or training necessary to satisfy any of the employer’s requirements for the job opportunity identified in Section F of the PWD identified in Question E.1? 
                        <span>{{checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'empPaidWorkerEducation')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'exceedsSVPRequirements')">
                <div class="main-list">
                    <p>
                        Do the job requirements identified in Section F of the PWD identified in Question E.1 exceed the Specific Vocational Preparation (SVP) level assigned to the occupation as shown in the O*NET Job Zones?
                        <span>{{checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'exceedsSVPRequirements')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" v-if="checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'usedCredentialingService')">
                <div class="main-list">
                    <p>
                        Did the employer use a credentialing service to qualify the foreign worker's education and/or experience requirements in Section F of the PWD identified in Question E.1
                        <span>{{checkProperty(petition['permEfileInfo'] ,'additionalJobInfo', 'usedCredentialingService')}}</span>
                    </p>
                </div>
            </div>
            <!-- <h4>Notice of Posting</h4> -->
            <div class="vx-col md:w-1/2 w-full" >
                <div class="main-list">
                    <p>
                        Bargaining Representative
                        <span>{{checkProperty(petition['permEfileInfo'] ,'noticeOfPosting', 'bargainingRep') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" >
                <div class="main-list">
                    <p>
                        No Bargaining Representative - Physical Notice
                        <span>{{checkProperty(petition['permEfileInfo'] ,'noticeOfPosting', 'nbPhysicalNotice') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" >
                <div class="main-list">
                    <p>
                        No Bargaining Representative - Electronic Notice
                        <span>{{checkProperty(petition['permEfileInfo'] ,'noticeOfPosting', 'nbElectronicNotice') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" >
                <div class="main-list">
                    <p>
                        No Bargaining Representative - In-House Notice
                        <span>{{checkProperty(petition['permEfileInfo'] ,'noticeOfPosting', 'nbInHouseNotice') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" >
                <div class="main-list">
                    <p>
                        No Bargaining Representative - Private Household
                        <span>{{checkProperty(petition['permEfileInfo'] ,'noticeOfPosting', 'nbPrivateHousehold') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full" >
                <div class="main-list">
                    <p>
                        The employer DID NOT post the notice of filing
                        <span>{{checkProperty(petition['permEfileInfo'] ,'noticeOfPosting', 'noNotice') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <!-- <h4>Special Recruitment for College and University Teachers</h4> -->
            <template v-if="checkProperty(petition, 'permEfileInfo', 'journalNamesAndDates') && checkProperty(petition['permEfileInfo'], 'journalNamesAndDates', 'length')>0 
                && checkProperty(petition['permEfileInfo']['journalNamesAndDates'][0], 'journalName')">
                <vs-table :data="petition.permEfileInfo.journalNamesAndDates"> 
                    
                    <template>
                        <template slot="thead">
                            <vs-th>Journal Name</vs-th>
                            <vs-th>Start date of advertisement</vs-th>
                            
                        </template>
                        <template>
                            <vs-tr :key="sin" v-for="(stay ,sin) in petition.permEfileInfo.journalNamesAndDates">
                                <vs-td> <span v-if="checkProperty( stay, 'journalName')">{{ stay.journalName }}</span></vs-td>
                                <vs-td><span v-if="checkProperty( stay, 'startDateOfAdv')">{{stay.startDateOfAdv | formatDate}}</span></vs-td>
                               
                            </vs-tr>
                        </template>
                    </template>
                </vs-table>
            </template>
            
           
            
        </div>
        </div>
    </div>
    </template>
    
    <script>
     import documentsView from "@/views/common/documentsView.vue";
    export default {
        props: {
            petition: {
                type: Object,
                default: null
            },
            visastatuses: {
                type: Array,
                default: null
            }
        },
        computed: {
            showRouteName(){
                if(this.$route.name == 'questionnaire'){
                    return false
                }
                else{
                    return true
                }
            }
        },
        methods:{
            download_or_view(value) {
                this.$emit('download_or_view' ,value);
            },
            formatWorkSite(val){
                let returnVal = '';
                let arry = [
                    {'id':1, 'name':'Business Premises'},
                    {'id':2, 'name':"Employer's private household (includes live-in and domestic household worker)"},
                    {'id':3, 'name':"Employee's private residence (when work is performed directly out of the residence)"},
                    {'id':4, 'name':"No one specific worksite address or physical location"}
                ]
                let findObj = _.find(arry, {'id':val});
                if(findObj){
                    returnVal = findObj['name']
                };
                return returnVal;
            }
        },
        components:{
            documentsView
        }
    };
    </script>
    